import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import type { SearchPreferencesUpdate } from "@searchui-searchforms/shared/user-preferences";
import { fciFetch } from "@/shared/lib/fci";

const fci = {
    // POST request to persist user search preferences.
    // A rejected direct persistence remains an action failure for FCI.
    errorType: FCI_ERROR.Action,
    errorInfo: "saveSearchPreferences",
};

export const saveSearchPreferences = async (update: SearchPreferencesUpdate): Promise<void> => {
    await fciFetch("/api/searchforms/search-preferences", {
        method: "POST",
        body: update,
        fci,
    });
};
